// extracted by mini-css-extract-plugin
export default {"folder":"EpyvRtTxEQHoww7WS2Nl","count":"uIt6i7vv6tSmheV2Pvdt","text":"G3xvveq8S1n6xRlbXpbd","select_btn":"QerpZNRTue5ao6hwblp8"};